import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storage.block.volume.details;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORAGE_BLOCK_VOLUME_DETAILS',
	method: 'POST',
	url: '/storage/block/volume/details.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
